import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem
} from "@emisgroup/ui-dropdown-menu";
import { Button } from "@emisgroup/ui-button";
import { ActionMenuDataType, EthnicityType } from "@emisgroup/cohort-builder-kit";
import { OutputConfigSlice } from "../redux";
import { Switch } from "../../../Common/UI/Index";
import { NotificationBanner } from "../../../Common/NotificationBanner/NotificationMessage";
import { IRootState } from "../../../../reducer/CombineReducer";
import { getNotificationTextBasedOnConfig, validateIfBandingMessage } from "../helper";
import { BANDINGSAVE } from "../Constant";
import { BandModeType, BandsTypes } from "./Types";
import { BandingDetailsProps } from "./Helper";
import TriangleDown from "~icons/ic/outline-arrow-drop-down";
import "./Style.scss";

/**
 * Responsible for creating the banding
 * @returns JSX element
 */
export const CreateBandingView: React.FC = () => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const notificationState = useSelector((state: IRootState) => state.notificationState);
  const [splitDropdownMenuOpen, setSplitDropdownMenuOpen] = useState(false);

  /**
   * Handler for clicking the manage bandings menu
   * @param typeOfBand 
   */
  const manageBandingsClick = (typeOfBand: BandsTypes): void => {
    let newItem;
    const ethnicityCategory: EthnicityType = "ETHNICITY";
    setSplitDropdownMenuOpen(false);
    const item = {
      ... {} as BandingDetailsProps,
      bandType: typeOfBand,
      bandMode: BandModeType.ADD,
    };
    if (typeOfBand === BandsTypes.ETHNICITY) {
      newItem = {
        ...item,
        ethnicityCategory: ethnicityCategory
      };
    } else newItem = item;
    dispatch(OutputConfigSlice.actions.setSelectedBandingDetails(newItem));
  };

  /**
   * Handler for add banding
   * @param isOpen flag value
   */
  const handleAddBanding = (isOpen: boolean): void => {
    setSplitDropdownMenuOpen(isOpen);
  };

  /**
   * Hide dropdown on scroll
   */
  const handleScroll = (): void => {
    setSplitDropdownMenuOpen(false);
  };

  /**
   * Register scroll event 
   */
  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true);

    // Remove the event listener
    return (): void => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  /**
   * Dropdown content
   */
  const drpDwnData: ActionMenuDataType[] = [
    {
      id: "1",
      name: BandsTypes.AGE,
      onClick: (): void => manageBandingsClick(BandsTypes.AGE)
    },
    {
      id: "2",
      name: BandsTypes.GENDER,
      onClick: (): void => manageBandingsClick(BandsTypes.GENDER)
    },
    {
      id: "3",
      name: BandsTypes.ETHNICITY,
      onClick: (): void => manageBandingsClick(BandsTypes.ETHNICITY)
    },
  ];

  const notificationMessage = getNotificationTextBasedOnConfig(notificationState.notificationItems, BANDINGSAVE);
  return (
    <>
      <Switch
        gap="0.5rem"
        threshold="40rem"
        className="ebt-bandinglist__switcher"
        id="ebt-outputConfig-banding-addBanding"
      >
        <span>
          <DropdownMenu
            onOpenChange={(data): void => handleAddBanding(data)}
            open={splitDropdownMenuOpen}
          >
            <DropdownMenuTrigger>
              <Button>
                {translate("OutputConfig.Banding.AddBanding")}
                <TriangleDown title="Expand" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="ebt-create-band-drpcontent">
              {drpDwnData.map((menu: ActionMenuDataType) => {
                return (
                  <DropdownMenuItem
                    key={menu.id}
                    onClick={menu?.onClick}
                  >
                    {menu.name}
                  </DropdownMenuItem>
                );
              })}
            </DropdownMenuContent>
          </DropdownMenu>
        </span>
      </Switch>
      {
        validateIfBandingMessage(notificationMessage, translate) &&
        <NotificationBanner message={notificationMessage} />
      }
    </>
  );
};
